import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1058"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.382 9.429a1.617 1.617 0 0 0-.965-.623c-.098-.87-.801-1.512-1.577-1.523-.62-.009-1.209.384-1.486.995a1.592 1.592 0 0 0-1.236.901c-.643-.086-1.098.25-1.298.651a.943.943 0 0 0-.665.072.9.9 0 0 0-.482.78c0 .391.271.711.596.833.403.151.76-.05.81-.079.093.079.437.352.947.353.408 0 .7-.173.812-.248.098.048.28.122.514.171L8.7 12.726a.128.128 0 0 0 .112.19h.86c.028 0 .048.027.04.053l-.593 2.036 2.488-2.643a.127.127 0 0 0-.093-.215h-.842a.042.042 0 0 1-.035-.064l.485-.588c.205.116.549.261.986.25.415-.011.725-.159.881-.247.067.032.456.206.872.031.424-.178.659-.626.638-1.033-.026-.537-.494-1.013-1.117-1.067z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.12a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }